import { Box, CircularProgress } from "@mui/material";

interface LoaderProps {
  size?: number;
  minHeight?: number | string;
}

export function Loader({ size, minHeight }: LoaderProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight,
      }}
    >
      <CircularProgress size={size} />
    </Box>
  );
}
